import tw from 'twin.macro'
import styled, { css } from 'styled-components'
import { BASE_MDX_WRAPPER_STYLES } from '../../wrapper/src/styles'
import { MdxWrapperProps } from '../../wrapper/src/types'

const TOP_MARGIN = css`
  ${tw`pt-5`}
`

export const Wrapper = styled.div<MdxWrapperProps>`
  ${BASE_MDX_WRAPPER_STYLES}

  ol,
  ul {
    li {
      ${TOP_MARGIN}
    }

    pre {
      ${TOP_MARGIN}
      ${tw`pl-8`}
    }
  }

  ol.alphabetic > li:before,
  ol > li > ol > li > ol > li:before {
    font-weight: bold;
    display: table-cell;
    width: 2.6rem;
    content: '(' counter(item, lower-alpha) ')';
  }

  ol {
    ${tw`list-decimal !pl-0`}
    list-style-type: none;
    counter-reset: item;

    li p:not(:first-child) {
      ${TOP_MARGIN}
    }

    ol {
      list-style-type: none;
      counter-reset: item;
    }

    > li {
      display: table;
      counter-increment: item;
    }

    > li:before,
    > li > ol > li:before {
      font-weight: bold;
      display: table-cell;
      width: 2.6rem;
    }
    > li:before {
      content: counters(item, '.') '.';
    }
    > li > ol > li:before {
      content: counters(item, '.');
    }

    li ol {
      ${tw`!pl-0`}
    }

    li ol > li {
      margin: 0;
      display: table;
    }
  }

  > ol > li:first-of-type {
    ${tw`pt-0`}
  }

  ul {
    list-style-type: circle;
  }

  pre,
  code {
    ${tw`font-sans`}
  }

  table {
    th {
      ${tw`text-start whitespace-nowrap`}
    }

    th,
    td {
      ${tw`p-4`}
    }

    tr {
      td {
        ${tw`border-t border-solid border-emerald-500 align-top`}
      }

      th {
        ${tw`align-top`}
      }

      td:not(:first-child),
      th:not(:first-child) {
        ${tw`border-l border-emerald-500`}
      }
    }
  }

  ${({ styles }) => styles ?? ''}
`
